<div class="input-password position-relative">
  <label class="col-form-label" v-if="label" :for="id" ref="labelForm">{{ label }}</label>
  <input class="form-control" :class="{ 'is-error': isError }" v-model="value" :type="type" :id="id" :disabled="disabled" />
  <div class="show-hide" :class="{ 'top-error': isError }" @click="showPassword">
    <IconEyeSlash v-if="!isShow"></IconEyeSlash>
    <IconEye v-if="isShow"></IconEye>
  </div>
  <div class="error-text" v-if="errorText" :style="{left: distanceWithLabel}">{{errorText}}</div>
</div>
